/**
 * Single source of truth for the Tournaments vocabulary. Components branch on
 * these, never on raw strings. Same idiom as `bettingConstants.js`.
 */

// Which list a tournament came from — drives which leaderboard query runs and
// whether Accept/Decline controls are eligible at all.
export const TOURNAMENT_ORIGIN = {
  ACTIVE: 'ACTIVE',
  HISTORY: 'HISTORY',
}

// Top-level TournamentsMenu tabs.
export const TOURNAMENTS_TAB = {
  CURRENT: { KEY: 'CURRENT', LABEL: 'Current Tournaments', ORIGIN: TOURNAMENT_ORIGIN.ACTIVE },
  HISTORY: { KEY: 'HISTORY', LABEL: 'Tournaments History', ORIGIN: TOURNAMENT_ORIGIN.HISTORY },
}

// TournamentOverviewTabs sub-tabs (inside a single tournament's detail view).
export const OVERVIEW_TAB = {
  LEADERBOARD: { KEY: 'LEADERBOARD', LABEL: 'Leaderboard' },
  PRIZES: { KEY: 'PRIZES', LABEL: 'Prizes' },
  RULES: { KEY: 'RULES', LABEL: 'Rules' },
}

// Reward shape on a leaderboard/prize row.
export const REWARD_TYPE = {
  FREEBET: 'FREEBET',
  AMOUNT: 'AMOUNT',
}

// Tournament type -> display label (ported verbatim from defenderV2's
// LIST_OF_TOURNAMENT_TYPES, including its inverted-sounding naming: the
// NUMBER_OF_BETS type displays as "Highest Bets", HIGHEST_BETS as "Highest Stake").
export const TOURNAMENT_TYPE_LABEL = {
  NUMBER_OF_BETS: 'Highest Bets Leaderboard',
  HIGHEST_BETS: 'Highest Stake Leaderboard',
}

// Per-user opt-in status — a STRING from ROOT (`isUserOptIn`), not a boolean.
// Confirmed live values: 'Active' (pending decision), 'Accepted', 'Declined'.
export const OPT_IN_STATUS = {
  ACTIVE: 'Active',
  ACCEPTED: 'Accepted',
  DECLINED: 'Declined',
}

// History tournament's legacy status badge (list card only — the detail
// card's footer is decided purely by `rank != null`, see tournamentCardView.js).
// Raw value casing is UNCONFIRMED live (defenderV2 itself has a casing bug
// here — a lowercase 'expired' status can never match its own uppercase-keyed
// lookup); this map is looked up case-insensitively to avoid inheriting that bug.
export const HISTORY_STATUS_VARIANT = {
  ACTIVE: { label: 'Active', variant: 'active' },
  DEFAULT: { label: 'Default', variant: 'default' },
  ACCEPTED: { label: 'Accepted', variant: 'accepted' },
  DECLINED: { label: 'Declined', variant: 'declined' },
  EXPIRED: { label: 'Expired', variant: 'expired' },
}

export const TOURNAMENTS_PAGE_SIZE = 10
export const TOURNAMENT_LEADERBOARD_PAGE_SIZE = 15
